module.exports = __webpack_public_path__ + "img/notifications.cc8692e0.svg";